import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import ScrollingAppWrapper from "ScrollingAppWrapper";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter } from "react-router-dom";
import { QueryClientProvider, QueryClient } from "@tanstack/react-query";
import "./fonts.css";
import { AuthProvider } from "BEDROCK/auth/auth-provider";
import { NavigationBarProvider } from "navigation-bar/navigation-bar-provider";
import { CheckoutProvider } from "BEDROCK/pages/checkout/checkout-provider";
import { ToastProvider } from "BEDROCK/shared-components/toast";
import { AppScrollProvider } from "use-app-scroll";
import { Analytics } from "@vercel/analytics/react";
import * as amplitude from "@amplitude/analytics-browser";
import { AnalyticsTracker } from "./analytics-tracker";
import { TouchModeProvider } from "BEDROCK/mobile";

const queryClient = new QueryClient();

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

amplitude.init("c64ab46fc2c43190323258cb5b10a097", {
  autocapture: false,
  optOut: process.env.REACT_APP_ENVIRONMENT !== "production",
});

root.render(
  <React.StrictMode>
    <BrowserRouter>
      <QueryClientProvider client={queryClient}>
        <TouchModeProvider>
          <div className="container">
          <AuthProvider>
            <AnalyticsTracker />
            <AppScrollProvider>
              <CheckoutProvider>
                <NavigationBarProvider>
                  <ToastProvider>
                    <div className="appContainer">
                      <ScrollingAppWrapper />
                    </div>
                  </ToastProvider>
                </NavigationBarProvider>
              </CheckoutProvider>
            </AppScrollProvider>
          </AuthProvider>
          <Analytics />
        </div>
        </TouchModeProvider>
      </QueryClientProvider>
    </BrowserRouter>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
